import React from 'react';

import TempNavOptions from '../../../DelegateAccess/NavOptionsContainer';

export default () => <TempNavOptions styleName="UserNav-Item" />;
